import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  activeInactiveUserDetailsAction,
  addUserDetailsAction,
  getHelloAdminAction,
  getProviderByChainIdAction,
  getRoleDetailByIdAction,
  getUserDetailByIdAction,
  getUserRoleAction,
} from "../../../redux/actions/HelloAdminAction";
import Select from "react-select";
import Modal from "react-modal";
import { Formik } from "formik";
import { YUPValidations, updateSubMenus } from "./helper";
import {
  getSnackbarSuccess,
  isLoadingAction,
  MandatoryStar,
} from "../../../Utils/helper";
import moment from "moment";

export const AddUserPopup = ({
  isEditUser,
  setIsEditUser,
  apiParams,
  searchFilter,
  canEdit,
}) => {
  const dispatch = useDispatch();
  const [data, setData] = useState({
    userTypeId: searchFilter?.userTypeId,
  });
  const [isDeactiveUser, setIsDeactiveUser] = useState(false);
  const [menuList, setMenuList] = useState(null);

  const getHelloAdminReducer = useSelector((state) => state?.HelloAdminReducer);

  useEffect(() => {
    if (isEditUser === 0) {
      const resp = dispatch(getUserDetailByIdAction(isEditUser));
      resp.then((res) => {
        setData({
          ...res?.data?.results,
          userTypeId: searchFilter?.userTypeId,
        });
        setMenuList(updateSubMenus(res?.data?.results?.userMenus));
      });
      dispatch(getUserRoleAction(data?.userTypeId));
    }
  }, [isEditUser]);

  useEffect(() => {
    dispatch(
      getProviderByChainIdAction({
        providerChainId: null,
        providerChainName: null,
      })
    );
  }, []);

  useEffect(() => {
    if (isEditUser) {
      const resp = dispatch(getUserDetailByIdAction(isEditUser));
      resp.then((res) => {
        dispatch(getUserRoleAction(res?.data?.results?.userTypeId));
        setData(res?.data?.results);
        setMenuList(updateSubMenus(res?.data?.results?.userMenus));
      });
    }
  }, [isEditUser]);

  const handleClose = async () => {
    setIsEditUser(null);
    setData(null);
    await dispatch(
      getHelloAdminAction({
        ...searchFilter,
        ...apiParams,
      })
    );
    await dispatch(getUserRoleAction(searchFilter?.userTypeId));
  };

  const getProviderValues = (providerIds) => {
    const arr = providerIds?.split(",")?.map((ele) => +ele);
    const res = getHelloAdminReducer?.getProvidersByChainId?.filter(
      ({ providerId }) => arr?.includes(providerId)
    );
    const temp = res?.map((ele) => {
      return {
        value: ele?.providerId,
        label: ele?.providerName,
      };
    });
    return temp;
  };

  const chainUserProviderId = getHelloAdminReducer?.getUserTypeDetails?.filter(
    (ele) => ele?.roleName === "Chain Provider"
  )?.[0]?.roleId;

  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black">
          {isEditUser === 0 ? "Add User Details" : "Edit User Details"}
        </h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={handleClose}
        ></button>
      </div>
      <Formik
        enableReinitialize={true}
        initialValues={{ ...data }}
        onSubmit={async (values) => {
          const parentMenu = menuList?.map((ele) => {
            return ({
              canEdit: ele?.menuItem?.canEdit,
              canView: ele?.menuItem?.canView,
              menuId: ele?.menuItem?.menuId,
              title: ele?.menuItem?.title
            })
          })
          const subMenu = menuList?.flatMap(item => item?.subMenus)
          const networkInformationToMenuMapIdArray = subMenu
            .filter(item => item.networkInformationToMenuMapId !== undefined)
            .map(item => item.networkInformationToMenuMapId);
          const filteredArray = subMenu.filter(item => {
            return !networkInformationToMenuMapIdArray.includes(item.networkInformationToMenuMapId);
          });
          const notFilteredArray = subMenu.filter(item => {
            return networkInformationToMenuMapIdArray.includes(item.networkInformationToMenuMapId);
          });
          const sortedNotFilteredArray = notFilteredArray?.map((ele) => {
            return ({
              networkInformationToMenuMapId: ele?.networkInformationToMenuMapId,
              informationName: ele?.title,
              canEdit: ele?.canEdit,
              canView: ele?.canView,
            })
          })
          const sortedSubMenuData = filteredArray?.map((ele) => {
            return ({
              canEdit: ele?.canEdit,
              canView: ele?.canView,
              menuId: ele?.menuId,
              title: ele?.title
            })
          })
          const menuPermission = [...parentMenu, ...sortedSubMenuData]
          const informationPermissionsOnly = menuList?.flatMap(item => item?.subMenus ? item?.subMenus?.flatMap(subMenu => subMenu?.informationPermissions) : []);
          const informationPermission = [...sortedNotFilteredArray, ...informationPermissionsOnly]
          const temp = {
            ...values,
            menuPermissions: menuPermission,
            InformationPermissions: informationPermission,
            userMenus: undefined
          };
          const resp = dispatch(addUserDetailsAction(temp));
          resp.then((res) => {
            isLoadingAction(true, dispatch);
            if (res?.data?.status === true) {
              getSnackbarSuccess("success", res?.data?.message, dispatch);
              isLoadingAction(false, dispatch);
              handleClose();
            } else {
              getSnackbarSuccess("error", res?.data?.message, dispatch);
              isLoadingAction(false, dispatch);
            }
          });
        }}
        validationSchema={YUPValidations}
      >
        {(props) => {
          const { values, errors, handleChange, handleSubmit, setFieldValue } =
            props;
          return (
            <form className="form-admin" onSubmit={handleSubmit}>
              <div className="modal-body addusermodalbox">
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor="User Type" className="col-form-label">
                      User Type
                      <MandatoryStar />
                    </label>
                    <select
                      name="userTypeId"
                      className="form-select form-select-admin"
                      value={values?.userTypeId}
                      onChange={(e) => {
                        dispatch(getUserRoleAction(e.target.value));
                        setFieldValue("userTypeId", e.target.value);
                        setFieldValue("roleIds", "");
                        setFieldValue("roleCode", "");
                      }}
                      disabled={
                        (isEditUser !== 0 && !canEdit) ||
                        (isEditUser !== 0 && !values?.isActive)
                      }
                    >
                      {getHelloAdminReducer?.getUserTypeDetails?.map(
                        (ele, index) => {
                          return (
                            <option key={index} value={ele?.roleId}>
                              {ele?.roleName}
                            </option>
                          );
                        }
                      )}
                    </select>
                    <div className="errorInputMessage">
                      {errors?.userTypeId}
                    </div>
                  </div>
                  {values?.userTypeId == chainUserProviderId && (
                    <div className="col-lg-6 col-md-6">
                      <label htmlFor="Chain Name" className="col-form-label">
                        Chain Name
                        <MandatoryStar />
                      </label>
                      <input
                        name="providerChainName"
                        type="text"
                        placeholder="Provider Chain Name"
                        className="form-control form-select-admin inputbgavanish"
                        value={values?.providerChainName}
                        onChange={handleChange}
                        disabled={
                          values?.userType === "PRVDR_CHAIN" ||
                          (isEditUser !== 0 && !canEdit) ||
                          (isEditUser !== 0 && !values?.isActive)
                        }
                      />
                      <div className="errorInputMessage">
                        {errors?.providerChainName}
                      </div>
                    </div>
                  )}
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor="Role" className="col-form-label">
                      Role
                      <MandatoryStar />
                    </label>
                    <select
                      name="roleIds"
                      className="form-select form-select-admin"
                      value={values?.roleIds}
                      onChange={(e) => {
                        setFieldValue("roleIds", e.target.value);
                        const resp = dispatch(
                          getRoleDetailByIdAction(e.target.value)
                        );
                        resp.then((res) => {
                          setMenuList(updateSubMenus(res?.data?.results?.userMenus));
                          setFieldValue(
                            "roleCode",
                            res?.data?.results?.roleCode
                          );
                        });
                      }}
                      disabled={
                        (isEditUser !== 0 && !canEdit) ||
                        (isEditUser !== 0 && !values?.isActive)
                      }
                    >
                      <option value="">Select Role</option>
                      {getHelloAdminReducer?.getUserRoleDetails?.map(
                        (ele, index) => {
                          return (
                            <option key={index} value={ele?.roleId}>
                              {ele?.roleName}
                            </option>
                          );
                        }
                      )}
                    </select>
                    <div className="errorInputMessage">{errors?.roleIds}</div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor=" Role" className="col-form-label">
                      First Name
                      <MandatoryStar />
                    </label>
                    <input
                      name="firstName"
                      type="text"
                      placeholder="First Name"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.firstName}
                      onChange={handleChange}
                      disabled={
                        (isEditUser !== 0 && !canEdit) ||
                        (isEditUser !== 0 && !values?.isActive)
                      }
                    />
                    <div className="errorInputMessage">{errors?.firstName}</div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor=" Role" className="col-form-label">
                      Last Name
                      <MandatoryStar />
                    </label>
                    <input
                      name="lastName"
                      type="text"
                      placeholder="Last Name"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.lastName}
                      onChange={handleChange}
                      disabled={
                        (isEditUser !== 0 && !canEdit) ||
                        (isEditUser !== 0 && !values?.isActive)
                      }
                    />
                    <div className="errorInputMessage">{errors?.lastName}</div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor="Email" className="col-form-label">
                      Email
                      <MandatoryStar />
                    </label>
                    <input
                      name="emailId"
                      type="text"
                      placeholder="Email"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.emailId}
                      onChange={handleChange}
                      disabled={
                        (isEditUser !== 0 && !canEdit) ||
                        (isEditUser !== 0 && !values?.isActive)
                      }
                    />
                    <div className="errorInputMessage">{errors?.emailId}</div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor="Mobile Number" className="col-form-label">
                      Mobile Number
                      <MandatoryStar />
                    </label>
                    <input
                      name="mobileNumber"
                      type="text"
                      minLength={10}
                      maxLength={10}
                      placeholder="Mobile Number"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.mobileNumber}
                      onChange={handleChange}
                      onKeyPress={(event) => {
                        const re = /[0-9]+/g;
                        if (!re.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      disabled={
                        (isEditUser !== 0 && !canEdit) ||
                        (isEditUser !== 0 && !values?.isActive)
                      }
                    />
                    <div className="errorInputMessage">
                      {errors?.mobileNumber}
                    </div>
                  </div>
                </div>
                {values?.userTypeId == chainUserProviderId && (
                  <div className="row" style={{ padding: "12px" }}>
                    <label htmlFor="Mobile Number" className="col-form-label">
                      Add Providers
                      <MandatoryStar />
                    </label>
                    <div className="search-test-div">
                      <Select
                        placeholder="Search Providers..."
                        options={getHelloAdminReducer?.getProvidersByChainId?.map(
                          (ele) => {
                            return {
                              value: ele?.providerId,
                              label: ele?.providerName,
                            };
                          }
                        )}
                        closeMenuOnSelect={false}
                        value={getProviderValues(values?.providerIds)}
                        isMulti
                        classNamePrefix="select"
                        name="colors"
                        isClearable={true}
                        onChange={(e) => {
                          setFieldValue(
                            "providerIds",
                            e?.map((ele) => ele.value)?.toString()
                          );
                        }}
                        required
                      />
                    </div>
                  </div>
                )}
                <h5 className="my-3">Menu Name</h5>
                <div class="accordion" id="accordionExample">
                  {menuList?.map((menu, menuIndex) => (
                    <div className="accordion-item" key={menuIndex}>
                      <h2
                        className="accordion-header"
                        id={`heading${menuIndex}`}
                      >
                        <div className="d-flex bg-parentcolor">
                          {menu.subMenus.length > 0 ? (
                            <button
                              className={`accordion-button role-accordion-button bg-parentcolor collapsed ${menu.subMenus.length ? "accordion-item-not" : ""
                                }`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapse${menuIndex}`}
                              aria-expanded="true"
                              aria-controls={`collapse${menuIndex}`}
                            >
                              {menu.menuItem.title}
                            </button>
                          ) : (
                            <button
                              className="accordion-button role-accordion-button bg-parentcolor accordion-icon-none"
                              style={{ border: "none" }}
                              type="button"
                            >
                              {menu.menuItem.title}
                            </button>
                          )}
                          <th className="role-th"></th>
                          {menu?.subMenus?.length <= 0 &&
                            <>
                              <th className="role-th" style={{justifyContent:"end"}}>
                                <p className="role-th-p">Edit </p>
                                <input
                                  className="input-checkbox-role"
                                  type="checkbox"
                                  onChange={(e) => {
                                    setMenuList(() => {
                                      return menuList.map((ele, index) => {
                                        if (index === menuIndex) {
                                          const updatedMenu = {
                                            ...ele,
                                            menuItem: {
                                              ...ele.menuItem,
                                              canEdit: e.target.checked,
                                              canView: e.target.checked,
                                            },
                                          };
                                          return updatedMenu;
                                        }
                                        return ele;
                                      });
                                    });
                                  }}
                                  checked={menu?.menuItem?.canEdit}
                                  disabled={
                                    (isEditUser !== 0 && !canEdit) ||
                                    (isEditUser !== 0 && !values?.isActive) ||
                                    values?.roleCode === "VIEW_ADMIN" ||
                                    values?.roleCode === "SUPER_ADMIN" ||
                                    values?.roleCode === "NW_VIEW_ADMIN" ||
                                    values?.roleCode === "NW_SUPER_ADMIN"
                                  }
                                />
                              </th>
                              <th className="role-th">
                                <p className="role-th-p">View</p>
                                <input
                                  className="input-checkbox-role"
                                  type="checkbox"
                                  onChange={(e) => {
                                    setMenuList(() => {
                                      return menuList.map((ele, index) => {
                                        if (index === menuIndex) {
                                          const updatedMenu = {
                                            ...ele,
                                            menuItem: {
                                              ...ele.menuItem,
                                              canEdit: !e.target.checked && false,
                                              canView: e.target.checked,
                                            },
                                          };
                                          return updatedMenu;
                                        }
                                        return ele;
                                      });
                                    });
                                  }}
                                  checked={menu?.menuItem?.canView}
                                  disabled={
                                    (isEditUser !== 0 && !canEdit) ||
                                    (isEditUser !== 0 && !values?.isActive) ||
                                    values?.roleCode === "VIEW_ADMIN" ||
                                    values?.roleCode === "SUPER_ADMIN" ||
                                    values?.roleCode === "NW_VIEW_ADMIN" ||
                                    values?.roleCode === "NW_SUPER_ADMIN"
                                  }
                                />
                              </th>
                            </>}
                        </div>
                      </h2>
                      <div
                        id={`collapse${menuIndex}`}
                        className="accordion-collapse collapse"
                        aria-labelledby={`heading${menuIndex}`}
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          {menu.subMenus.length > 0 &&
                            menu.subMenus.map((subMenu, subIndex) => (
                              <div
                                className="accordion"
                                id={`sub-accordion${subIndex}`}
                                key={subMenu.subIndex}
                              >
                                <div className="accordion-item">
                                  <h2
                                    className="accordion-header"
                                    id={`sub-heading${subIndex}`}
                                  >
                                    <div className="d-flex bg-subcolor">
                                      {subMenu?.informationPermissions?.length >
                                        0 ? (
                                        <button
                                          className="accordion-button role-accordion-button collapsed bg-subcolor"
                                          type="button"
                                          data-bs-toggle="collapse"
                                          data-bs-target={`#sub-collapse${subIndex}`}
                                          aria-expanded="true"
                                          aria-controls={`sub-collapse${subIndex}`}
                                        >
                                          {subMenu.title}
                                        </button>
                                      ) : (
                                        <button
                                          className="accordion-button role-accordion-button bg-subcolor accordion-icon-none"
                                          style={{ border: "none" }}
                                          type="button"
                                        >
                                          {subMenu.title}
                                        </button>
                                      )}
                                      {subMenu?.informationPermissions?.length <= 0 &&
                                        <> 
                                          <th className="role-th" style={{justifyContent:"end"}}>
                                            <p className="role-th-p">Edit</p>
                                            <input
                                              className="input-checkbox-role"
                                              type="checkbox"
                                              onChange={(e) => {
                                                setMenuList((prevMenuList) => {
                                                  return prevMenuList.map((ele, index) => {
                                                    if (index === menuIndex) {
                                                      const updatedSubMenus = ele?.subMenus?.map((subMenu, subMenuIndex) => {
                                                        if (subMenuIndex === subIndex) {
                                                          return {
                                                            ...subMenu,
                                                            canEdit: e.target.checked,
                                                            canView: e.target.checked,
                                                          };
                                                        }
                                                        return subMenu;
                                                      });
                                                      return {
                                                        ...ele,
                                                        menuItem: {
                                                          ...ele?.menuItem,
                                                          canEdit: updatedSubMenus?.some(subMenu => subMenu.canEdit === true) ? true : false,
                                                          canView: updatedSubMenus?.some(subMenu => subMenu.canView === true) ? true : false,
                                                        },
                                                        subMenus: updatedSubMenus || ele.subMenus,
                                                      };
                                                    }
                                                    return ele;
                                                  });
                                                });
                                              }}
                                              checked={subMenu?.canEdit}
                                              disabled={
                                                (isEditUser !== 0 && !canEdit) ||
                                                (isEditUser !== 0 && !values?.isActive) ||
                                                values?.roleCode === "VIEW_ADMIN" ||
                                                values?.roleCode === "SUPER_ADMIN" ||
                                                values?.roleCode === "NW_VIEW_ADMIN" ||
                                                values?.roleCode === "NW_SUPER_ADMIN"
                                              }
                                            />
                                          </th>
                                          <th className="role-th">
                                            <p className="role-th-p">View</p>
                                            <input
                                              className="input-checkbox-role"
                                              type="checkbox"
                                              onChange={(e) => {
                                                setMenuList((prevMenuList) => {
                                                  return prevMenuList.map((ele, index) => {
                                                    if (index === menuIndex) {
                                                      const updatedSubMenus = ele?.subMenus?.map((subMenu, subMenuIndex) => {
                                                        if (subMenuIndex === subIndex) {
                                                          return {
                                                            ...subMenu,
                                                            canEdit: !e.target.checked && false,
                                                            canView: e.target.checked,
                                                          };
                                                        }
                                                        return subMenu;
                                                      });
                                                      return {
                                                        ...ele,
                                                        menuItem: {
                                                          ...ele?.menuItem,
                                                          canView: updatedSubMenus?.some(subMenu => subMenu.canView === true) ? true : false,
                                                        },
                                                        subMenus: updatedSubMenus || ele.subMenus,
                                                      };
                                                    }
                                                    return ele;
                                                  });
                                                });
                                              }}
                                              checked={subMenu?.canView}
                                              disabled={
                                                (isEditUser !== 0 && !canEdit) ||
                                                (isEditUser !== 0 && !values?.isActive) ||
                                                values?.roleCode === "VIEW_ADMIN" ||
                                                values?.roleCode === "SUPER_ADMIN" ||
                                                values?.roleCode === "NW_VIEW_ADMIN" ||
                                                values?.roleCode === "NW_SUPER_ADMIN"
                                              }
                                            />
                                          </th>
                                        </>
                                      }
                                    </div>
                                  </h2>
                                  <div
                                    id={`sub-collapse${subIndex}`}
                                    className="accordion-collapse collapse"
                                    aria-labelledby={`sub-heading${subIndex}`}
                                    data-bs-parent={`#sub-accordion${subIndex}`}
                                  >
                                    {subMenu?.informationPermissions?.length ? (
                                      <div className="accordion-body">
                                        {subMenu?.informationPermissions?.map(
                                          (
                                            informationPermissionData,
                                            informationPermissionIndex
                                          ) => {
                                            return (
                                              <div
                                                className="d-flex bg-informationcolor"
                                                key={informationPermissionIndex}
                                              >
                                                <button
                                                  className="role-accordion-button bg-informationcolor text-start"
                                                  style={{ border: "none" }}
                                                  type="button"
                                                >
                                                  {
                                                    informationPermissionData.informationName
                                                  }
                                                </button>
                                                <th className="role-th" style={{justifyContent:"end"}}>
                                                  <p className="role-th-p">
                                                    Edit
                                                  </p>
                                                  <input
                                                    className="input-checkbox-role"
                                                    type="checkbox"
                                                    onChange={(e) => {
                                                      setMenuList((prevMenuList) => {
                                                        return prevMenuList.map((ele, index) => {
                                                          if (index === menuIndex) {
                                                            const updatedSubMenus = ele?.subMenus?.map((subMenu, subMenuIndex) => {
                                                              if (subMenuIndex === subIndex) {
                                                                const updatedInformationPermissions = subMenu
                                                                  ?.informationPermissions?.map((informationMenu, infoIndex) => {
                                                                    if (infoIndex === informationPermissionIndex) {
                                                                      return {
                                                                        ...informationMenu,
                                                                        canEdit: e.target.checked,
                                                                        canView: e.target.checked,
                                                                      };
                                                                    }
                                                                    return informationMenu;
                                                                  }) || [];

                                                                return {
                                                                  ...subMenu,
                                                                  canEdit: updatedInformationPermissions?.some(updatedMenu => updatedMenu.canEdit === true) ? true : false,
                                                                  canView: updatedInformationPermissions?.some(updatedMenu => updatedMenu.canView === true) ? true : false,
                                                                  informationPermissions: updatedInformationPermissions,
                                                                };
                                                              }
                                                              return subMenu;
                                                            });

                                                            return {
                                                              ...ele,
                                                              menuItem: {
                                                                ...ele?.menuItem,
                                                                canEdit: updatedSubMenus?.some(subMenu => subMenu.canEdit === true) ? true : false,
                                                                canView: updatedSubMenus?.some(subMenu => subMenu.canView === true) ? true : false,
                                                              },
                                                              subMenus: updatedSubMenus || ele.subMenus,
                                                            };
                                                          }
                                                          return ele;
                                                        });
                                                      });
                                                    }}
                                                    checked={
                                                      informationPermissionData.canEdit
                                                    }
                                                    disabled={
                                                      (isEditUser !== 0 && !canEdit) ||
                                                      (isEditUser !== 0 && !values?.isActive) ||
                                                      values?.roleCode === "VIEW_ADMIN" ||
                                                      values?.roleCode === "SUPER_ADMIN" ||
                                                      values?.roleCode === "NW_VIEW_ADMIN" ||
                                                      values?.roleCode === "NW_SUPER_ADMIN"
                                                    }
                                                  />
                                                </th>
                                                <th className="role-th">
                                                  <p className="role-th-p">
                                                    View
                                                  </p>
                                                  <input
                                                    className="input-checkbox-role"
                                                    type="checkbox"
                                                    onChange={(e) => {
                                                      setMenuList((prevMenuList) => {
                                                        return prevMenuList.map((ele, index) => {
                                                          if (index === menuIndex) {
                                                            const updatedSubMenus = ele?.subMenus?.map((subMenu, subMenuIndex) => {
                                                              if (subMenuIndex === subIndex) {
                                                                const updatedInformationPermissions = subMenu
                                                                  ?.informationPermissions?.map((informationMenu, infoIndex) => {
                                                                    if (infoIndex === informationPermissionIndex) {
                                                                      return {
                                                                        ...informationMenu,
                                                                        canEdit: !e.target.checked && false,
                                                                        canView: e.target.checked,
                                                                      };
                                                                    }
                                                                    return informationMenu;
                                                                  }) || [];

                                                                return {
                                                                  ...subMenu,
                                                                  canView: updatedInformationPermissions?.some(updatedMenu => updatedMenu.canView === true) ? true : false,
                                                                  informationPermissions: updatedInformationPermissions,
                                                                };
                                                              }
                                                              return subMenu;
                                                            });

                                                            return {
                                                              ...ele,
                                                              menuItem: {
                                                                ...ele?.menuItem,
                                                                canView: updatedSubMenus?.some(subMenu => subMenu.canView === true) ? true : false,
                                                              },
                                                              subMenus: updatedSubMenus || ele.subMenus,
                                                            };
                                                          }
                                                          return ele;
                                                        });
                                                      });
                                                    }}
                                                    checked={
                                                      informationPermissionData.canView
                                                    }
                                                    disabled={
                                                      (isEditUser !== 0 && !canEdit) ||
                                                      (isEditUser !== 0 && !values?.isActive) ||
                                                      values?.roleCode === "VIEW_ADMIN" ||
                                                      values?.roleCode === "SUPER_ADMIN" ||
                                                      values?.roleCode === "NW_VIEW_ADMIN" ||
                                                      values?.roleCode === "NW_SUPER_ADMIN"
                                                    }
                                                  />
                                                </th>
                                              </div>
                                            );
                                          }
                                        )}
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="modal-footer modal-footer-admin accept-reject-btns  accept-reject-btns-admin bottom-0  mt-4">
                <div className="created-by">
                  {isEditUser !== 0 && (
                    <p className="created-by-p">
                      {data?.createdBy !== null &&
                        `Created By ${data?.createdBy}`}
                      {data?.createdDateTime !== null &&
                        `| ${moment(data?.createdDateTime).format(
                          "DD MMMM YYYY"
                        )}`}
                    </p>
                  )}
                </div>
                <div className="d-flex justify-content-end flex-wrap gap-10">
                  {isEditUser !== 0 && canEdit && (
                    <a
                      type="button"
                      className={`${data?.isActive ? "deactive-button" : "active-button"
                        }`}
                      onClick={() => {
                        setIsDeactiveUser(true);
                      }}
                    >
                      {data?.isActive === true
                        ? "Deactivate User"
                        : "Activate User"}
                    </a>
                  )}
                  {((data?.isActive && canEdit) || isEditUser === 0) && (
                    <button type="submit" className="savedetails">
                      Save Details
                    </button>
                  )}
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
      <Modal
        isOpen={isDeactiveUser}
        className="modal-confirmation-popup"
        overlayClassName="overlay-confirmation-popup  network-z-index"
        ariaHideApp={false}
      >
        <>
          <div className="modal-body modal-body-active-popup popup-text">
            Are you sure you want to
            {data?.isActive ? " Deactive" : " Active"} this user ?
          </div>
          <div className="modal-footer modal-footer-active-popup">
            <button
              type="button"
              className="btn btn-primary"
              style={{ width: "90px" }}
              onClick={async () => {
                await setIsDeactiveUser(false);
                await dispatch(
                  activeInactiveUserDetailsAction(
                    isEditUser,
                    data?.isActive ? false : true
                  )
                );
                handleClose();
              }}
            >
              Yes
            </button>
            <button
              type="button"
              className="btn btn-primary btn-logout-no"
              onClick={() => {
                setIsDeactiveUser(false);
              }}
            >
              No
            </button>
          </div>
        </>
      </Modal>
    </>
  );
};
